import Swal from 'sweetalert2';

const normalizePdfFileName = (fileName = 'RezRATE_Print_Materials') => {
  const sanitized = `${fileName || 'RezRATE_Print_Materials'}`.trim();
  return sanitized.toLowerCase().endsWith('.pdf') ? sanitized : `${sanitized}.pdf`;
};

const writeLoadingMessage = (popupWindow) => {
  if (!popupWindow) {
    return;
  }

  try {
    popupWindow.document.title = 'Generating PDF...';
    popupWindow.document.body.style.margin = '0';
    popupWindow.document.body.style.fontFamily = 'Arial, sans-serif';
    popupWindow.document.body.style.display = 'flex';
    popupWindow.document.body.style.alignItems = 'center';
    popupWindow.document.body.style.justifyContent = 'center';
    popupWindow.document.body.style.minHeight = '100vh';
    popupWindow.document.body.innerHTML =
      '<div style="text-align:center;padding:24px;"><h2 style="margin:0 0 8px;">Generating PDF...</h2><div>Please wait.</div></div>';
  } catch (err) {
    // Ignore write failures and continue to use the popup if it exists.
  }
};

const showPopupBlockedAlert = ({ pdfDocGenerator, downloadTitle, allowDownloadFallback = true }) => {
  const normalizedTitle = normalizePdfFileName(downloadTitle);

  Swal.fire({
    title: 'Popup Blocked',
    html:
      'Your browser blocked opening the PDF in a new tab.<br><br>Allow popups for this site if you want PDFs to open in a new tab.',
    icon: 'warning',
    showCancelButton: allowDownloadFallback,
    confirmButtonText: allowDownloadFallback ? 'Download PDF' : 'OK',
    cancelButtonText: 'Close',
  }).then((result) => {
    if (allowDownloadFallback && result.isConfirmed) {
      pdfDocGenerator.download(normalizedTitle);
    }
  });
};

export const openPdfInNewTabOrAlert = ({
  pdfDocGenerator,
  downloadTitle,
  allowDownloadFallback = true,
  previewCallback,
}) => {
  const normalizedTitle = normalizePdfFileName(downloadTitle);

  if (previewCallback) {
    pdfDocGenerator.getBlob((blob) => {
      if (!blob) {
        previewCallback(null, normalizedTitle, new Error('Unable to generate PDF preview.'));
        Swal.fire('Error', 'Unable to preview the PDF. Please try again.', 'error');
        return;
      }

      const blobUrl = URL.createObjectURL(blob);
      previewCallback(blobUrl, normalizedTitle, null);
    });
    return;
  }

  let popupWindow = null;
  try {
    // We intentionally open a same-origin placeholder first so we can reliably tell whether the browser
    // blocked the popup. Chrome may return null for successful opens when noopener/noreferrer is passed.
    // eslint-disable-next-line no-restricted-syntax
    popupWindow = window.open('', '_blank');
    if (popupWindow) {
      popupWindow.opener = null;
      writeLoadingMessage(popupWindow);
    }
  } catch (err) {
    popupWindow = null;
  }

  if (!popupWindow) {
    showPopupBlockedAlert({ pdfDocGenerator, downloadTitle: normalizedTitle, allowDownloadFallback });
    return;
  }

  pdfDocGenerator.getBlob((blob) => {
    if (!blob) {
      try {
        popupWindow.close();
      } catch (err) {
        // Ignore close failures.
      }
      Swal.fire('Error', 'Unable to open the PDF. Please try again.', 'error');
      return;
    }

    const blobUrl = URL.createObjectURL(blob);

    try {
      popupWindow.location.replace(blobUrl);
      if (popupWindow.focus) {
        popupWindow.focus();
      }
      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 60000);
    } catch (err) {
      try {
        popupWindow.close();
      } catch (closeErr) {
        // Ignore close failures.
      }
      URL.revokeObjectURL(blobUrl);
      Swal.fire('Error', 'Unable to open the PDF. Please try again.', 'error');
    }
  });
};
